import { get } from 'lodash';

export const extractRepeaterImages = (data, fieldConfig) => {
  return data.reduce((acc, item) => {
    let allRepeaterImages = [];
    
    // For each repeater field, get the repeater items
    fieldConfig.repeaterImageFields.forEach(field => {
      const repeaterItems = get(item, field, []);
      if (repeaterItems && repeaterItems.length) {
        allRepeaterImages = [...allRepeaterImages, ...repeaterItems];
      }
    });
    
    const id = item._id;
    
    // Map metadata for each repeater image
    const repeaterImageData = allRepeaterImages.map(image => {
      const metaData = {};
      
      // For each metadata field, get the value from the appropriate path
      Object.entries(fieldConfig.metadataFields).forEach(([key, path]) => {
        metaData[key] = get(item, path);
      });
      
      return {
        ...image,
        id,
        metaData
      };
    });
    
    return [...acc, ...repeaterImageData];
  }, []);
};